import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import styles from "@/components/Layout/Layout.module.css";

export const Layout = () => {
    return (
        <div className={styles.layout}>
            {/* Extend Layout of the application with other components here */}
            {/* Suspense is used because app pages are lazy loaded */}
            <Suspense>
                <Outlet />
            </Suspense>
        </div>
    );
};
